import { useEffect } from 'react';

const useSmoothScrollOnVisible = (visible: boolean, scrollTop: number) => {
  useEffect(() => {
    if (visible) {
      window.scrollBy({ top: scrollTop, behavior: 'smooth' });
    }
  }, [visible, scrollTop]);
};

export default useSmoothScrollOnVisible;
